import React from 'react'
import { Col, Form } from 'react-bootstrap'
import Price from '../Price'
const PleatToTheStripe = (props) => {

   const { options, formState, setFormState, basketState, setBasketState } = props


   const setPleatToTheStripe = (checked) => {
      formState['pleatToTheStripe'] = checked
      setFormState({ ...formState })
      if (checked) {
         basketState['pleatToTheStripe'] = options
      } else {
         delete basketState['pleatToTheStripe']
      }
      setBasketState(basketState)
   }

   const label = <>Pleat to the stripe <Price {...options.price} /></>
   return (
      <Form.Group as={Col} xs={12} className='mb-3'>
         <Form.Check
            type="switch"
            id="custom-switch"
            label={label}
            onChange={(event) => {
               if (event.target.checked) {
                  setPleatToTheStripe(true)
               } else {
                  setPleatToTheStripe(false)
               }
            }}
         />
      </Form.Group>
   )
}
export default PleatToTheStripe